import React from "react";
import FloatingLabelInput from "../../../common/components/FloatingLabelInput";
import { t } from "i18next";

export default function PersonalInfo({ userInfo }) {
    return (
        <div>
            <h3 className="text-base font-semibold text-gray-800 mb-5">{t('personalData')}</h3>
            <form className="flex flex-col gap-4 max-w-md">
                <FloatingLabelInput
                    label={t('nameLabel')}
                    value={userInfo.name || ""}
                    onChange={() => {}}
                    type="text"
                    readOnly
                />
                <FloatingLabelInput
                    label={t('phoneNumber')}
                    value={userInfo.phone_number || ""}
                    mask="+7 (999) 999-99-99"
                    onChange={() => {}}
                    type="text"
                    readOnly
                />
                <div>
                    <button
                        type="submit"
                        className="bg-[#147F26] text-white py-2.5 px-6 rounded-xl font-medium hover:bg-[#0f5f1a] transition"
                    >
                        {t('save')}
                    </button>
                </div>
            </form>
        </div>
    );
}
